import _ from "lodash";
import React, { useState } from "react";
import classnames from "classnames";
import { FormattedMessage } from "react-intl";

import { Counter } from "../../../../../components/counter/Counter";
import { ScheduleRuleListItem } from "./ScheduleRuleListItem";
import { SCHEDULE_LIMIT } from "../schedules.selectors";
import { ScheduleRuleHint } from "../scheduleRuleHint/ScheduleRuleHint";

import "./ScheduleRuleList.scss";
import { changeSchedule, removeSchedule } from "../schedules.actions";
import { useDispatch } from "react-redux";

export const ScheduleRuleList = ({
  schedules,
  activeRule,
  setActiveRule,
  isActive: isScheduleActive,
  type,
  disabled,
}) => {
  const dispatch = useDispatch();
  const [statusInfo, setStatusInfo] = useState("");

  const handleScheduleRemove = (id) => () => {
    dispatch(removeSchedule(id));
    setStatusInfo("aria_draft_schedule_removed");

    setTimeout(() => setStatusInfo(""), 1000);
  };
  const handleScheduleChange = (schedule) => (changes) => {
    dispatch(changeSchedule({ ...schedule, ...changes }));
  };

  const scheduleType = schedules[0] ? schedules[0].type : type;

  return (
    <div className="schedule__rule">
      <div className={"sr-only"} role={"status"}>
        {statusInfo && <FormattedMessage id={statusInfo} />}
      </div>
      <div className="schedule__rule-title">
        <Counter
          label={
            <h4>
              <FormattedMessage id={"rules"} />
            </h4>
          }
          amount={schedules.length}
          limit={SCHEDULE_LIMIT}
        />
      </div>
      <div
        role={"list"}
        className="schedule__rule-list"
        id={`scheduleRuleList-${scheduleType}`}
      >
        {_.map(schedules, (schedule) => (
          <ScheduleRuleListItem
            className={classnames("schedule__rule-list__item", {
              "schedule__rule-list__item--active": schedule.id === activeRule,
            })}
            key={schedule.id}
            schedule={schedule}
            schedules={schedules}
            onMouseEnter={() => setActiveRule(schedule.id)}
            onMouseLeave={() => setActiveRule(null)}
            isScheduleActive={isScheduleActive}
            disabled={disabled}
            onScheduleRemove={handleScheduleRemove(schedule.id)}
            onScheduleChange={handleScheduleChange(schedule)}
          />
        ))}
        {schedules.length === 1 && <ScheduleRuleHint />}
      </div>
    </div>
  );
};
